import React, { createContext, useContext, useState, useRef, useCallback, useEffect } from "react";
import axiosInstance from "../Config/axios";
import { Toast } from "primereact/toast";
import { useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";

const SessionContext = createContext();
export const useSession = () => useContext(SessionContext);

export const SessionProvider = ({ children }) => {
  const navigate = useNavigate();
  const [listPackages, setListPackages] = useState([]);
  const [location, setLocation] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedSportEvents, setSelectedSportEvents] = useState([]);
  const [confirmBookingMsg, setConfirmBookingMsg] = useState({});
  const toastRef = useRef(null);

  const clearPackages = () => setListPackages([]);

  const fetchPackages = useCallback(async () => {
    setLoading(true)
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
       Swal.fire({
            icon: "error",
            title: "Error",
            text: "Access token missing. Please log in again.",
            confirmButtonColor: "#B79527", // orange / gold
            cancelButtonColor: "#1C1C1C",
          });
      clearPackages();
      localStorage.clear();
      navigate("/login", { replace: true });
      return;
    }

    try {
      const response = await axiosInstance.get("/scheduler/my-packages", {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      // console.log(response.data);
      
      setListPackages(response.data);
      setLoading(false)
    } catch (err) {
      const errorDetail = err.response?.data?.detail || "Failed to fetch pacakages";
     
       setLoading(false)
    }
  }, []);


  const fetchLocation = async () => {
    const accessToken = localStorage.getItem("accessToken");
    
    if (!accessToken) {
       Swal.fire({
            icon: "error",
            title: "Error",
            text: "Access token missing. Please log in again.",
            confirmButtonColor: "#B79527", // orange / gold
            cancelButtonColor: "#1C1C1C",
          });
      clearPackages();
      localStorage.clear();
      navigate("/login", { replace: true });
      return;
    }

    try {
      const response = await axiosInstance.get(`/adminpanel/locations/`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      setLocation(response.data);
      
      
    } catch (err) {
      const errorDetail = err.response?.data?.detail || "Failed to fetch locations";
   
    }
  };



  const fetchSportEvents = async (sportId, saleId, locationId, date, startTime, endTime, timeZone, player_ID,sporttype) => {
    const accessToken = localStorage.getItem("accessToken");
    const userDetails = JSON.parse(localStorage.getItem("user"));
    if (!accessToken) {
       Swal.fire({
            icon: "error",
            title: "Error",
            text: "Access token missing. Please log in again.",
            confirmButtonColor: "#B79527", // orange / gold
            cancelButtonColor: "#1C1C1C",
          });
      clearPackages();
      localStorage.clear();
      navigate("/login", { replace: true });
      return;
    }
    

    try {
      if(userDetails.is_self_pay === false){
        let playerID = "";
        if(player_ID){
          playerID = `&player_id=${player_ID}`;

        }else{
          playerID = "";
        }
        const response = await axiosInstance.get(`/scheduler/get_sport_events/?sport_id=${sportId}${playerID}`, {
            headers: { Authorization: `Bearer ${accessToken}` },
            params: {
              location: locationId,
              date: date,               
              start_time: startTime,    
              end_time: endTime,
              timezone: timeZone,         
              type: sporttype
            }
          });
          // setSportEvents(response.data);
          return response.data.events;

      }else{
        if (sportId && saleId) {

          let playerID = "";
          if(player_ID){
            playerID = `&player_id=${player_ID}`;

          }else{
            playerID = "";
          }

          
          const response = await axiosInstance.get(`/scheduler/get_sport_events/?sport_id=${sportId}&sale_id=${saleId}${playerID}`, {
            headers: { Authorization: `Bearer ${accessToken}` },
            params: {
              location: locationId,
              date: date,               
              start_time: startTime,    
              end_time: endTime,
              timezone: timeZone         
            }
          });
          // setSportEvents(response.data);
          return response.data.events;
        }
      }

    } catch (err) {
      const errorDetail = err.response?.data?.detail || "Failed to fetch sports events";
      // toastRef.current?.show({
      //   severity: "error",
      //   summary: "Error",
      //   detail: errorDetail,
      //   life: 3000,
      // });
    }
  };

  const checkBookingEvents = async (data) => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
       Swal.fire({
            icon: "error",
            title: "Error",
            text: "Access token missing. Please log in again.",
            confirmButtonColor: "#B79527", // orange / gold
            cancelButtonColor: "#1C1C1C",
          });
      clearPackages();
      localStorage.clear();
      navigate("/login", { replace: true });
      return;
    }
    
    try {
        const response = await axiosInstance.post(`/scheduler/check-booking/`,data, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        // setSportEvents(response.data);
        if(response.data &&response.data.possible === true){
          setSelectedSportEvents(response.data.events);
          return response.data;
        }else{
          return response.data;
        }
    } catch (err) {
      const errorDetail = err.response?.data?.message || err.response?.data?.error || "Failed to check booking";
      Swal.fire({
         icon: "error",
         title: "Failed",
         text: errorDetail,
         confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
       });
       return err.response?.data;
    }
  };


  const confirmBookingEvents = async (data) => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
       Swal.fire({
            icon: "error",
            title: "Error",
            text: "Access token missing. Please log in again.",
            confirmButtonColor: "#B79527", // orange / gold
            cancelButtonColor: "#1C1C1C",
          });
      clearPackages();
      localStorage.clear();
      navigate("/login", { replace: true });
      return;
    }
    
    try {
        const response = await axiosInstance.post(`/scheduler/confirm-booking/`, data , {
          headers: { Authorization: `Bearer ${accessToken}` },
          
        });
        setConfirmBookingMsg(response.data);
        navigate(`/confirm-booking`);
       
    } catch (err) {
      const errorDetail = err.response?.data?.message || "Failed to confirm your booking";
       Swal.fire({
      icon: "error",
      title: "Error",
      text: errorDetail,
      confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
    });
    }
  };


  // fetch my session 

  const fetchMySessions = async () => {
    setLoading(true);
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
       Swal.fire({
            icon: "error",
            title: "Error",
            text: "Access token missing. Please log in again.",
            confirmButtonColor: "#B79527", // orange / gold
            cancelButtonColor: "#1C1C1C",
          });
      clearPackages();
      localStorage.clear();
      navigate("/login", { replace: true });
      setLoading(false);
      return;
    }

    try {
      const response = await axiosInstance.get(`/customer/my-event-bookings/`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      // console.log("My Event Bookings:", response?.data);
      setLoading(false);
      return response?.data;
    } catch (err) {
      const errorDetail =
        err.response?.data?.detail || "Failed to fetch your event bookings";
      
      setLoading(false);
    }
  };

  // for check booking cancel status 
  const checkBookingCancelStatus = async (bookingId) => {
  const accessToken = localStorage.getItem("accessToken");
  if (!accessToken) {
     Swal.fire({
          icon: "error",
          title: "Error",
          text: "Access token missing. Please log in again.",
          confirmButtonColor: "#B79527", // orange / gold
          cancelButtonColor: "#1C1C1C",
        });
    clearPackages();
    localStorage.clear();
    navigate("/login", { replace: true });
    return;
  }

  try {
    const response = await axiosInstance.get(`/customer/bookings/${bookingId}/check-cancel/`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    
    return response.data;
  } catch (err) {
    const errorDetail = err.response?.data?.detail || "Failed to check cancel status";
    
    return null;
  }
};

// for cancel sessions 
const cancelBooking = async (bookingId, isLateCancel, cancellationFee) => {
  const accessToken = localStorage.getItem("accessToken");
  if (!accessToken) {
     Swal.fire({
          icon: "error",
          title: "Error",
          text: "Access token missing. Please log in again.",
          confirmButtonColor: "#B79527", // orange / gold
          cancelButtonColor: "#1C1C1C",
        });
    clearPackages();
    localStorage.clear();
    navigate("/login", { replace: true });
    return null;
  }

  try {
    let body = null;

    
    if (isLateCancel) {
      const formData = new FormData();
      formData.append("confirm_cancellation_fee", true);
      body = formData;
    }

    const response = await axiosInstance.patch(
      `/customer/bookings/${bookingId}/cancel/`,
      body,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    Swal.fire({
      icon: "success",
      title: "Booking Cancelled",
      text: response.data?.message || "Your session has been cancelled successfully.",
      confirmButtonColor: "#B79527",
      cancelButtonColor: "#1C1C1C",
    });

    return response.data;
  } catch (err) {
    const errorDetail = err.response?.data?.detail || "Failed to cancel the booking";
    Swal.fire({
      icon: "error",
      title: "Error",
      text: errorDetail,
      confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
    });
    return null;
  }
};


  useEffect(() => {
  const token = localStorage.getItem("accessToken");
  const storedUser = localStorage.getItem("user");

  if (!token || !storedUser) return;

  // fetchPackages(); 
  // fetchLocation()
}, []);


  

  return (
    <SessionContext.Provider value={{loading,fetchMySessions, listPackages, 
    fetchPackages, location, fetchLocation,  fetchSportEvents, checkBookingEvents,
     confirmBookingEvents, selectedSportEvents, confirmBookingMsg , checkBookingCancelStatus, cancelBooking}}>
      <Toast ref={toastRef} />
      {children}
    </SessionContext.Provider>
  );
};
